<div class="pj-password-form">
  <div class="pj-password-form__fields-row">
  <div class="pj-password-form__field" data-pj-password-field="password">
    <aprova-input
      _id="pj-password"
      [inputType]="!showPassword() ? 'password' : 'text'"
      [control]="form.controls.password"
      label="Senha"
      (onFocus)="showPasswordRulesTooltip('password', $event)"
      (onBlur)="clearFocusedField()"
      (onInput)="validatePasswordRules()"
    >
      <ng-container append>
        <aprova-icon
          [name]="!showPassword() ? 'eye-off-outline' : 'eye-outline'"
          size="20px"
          color="#9ca3af"
          class="cursor-pointer"
          (click)="togglePassword()"
        />
      </ng-container>
    </aprova-input>
  </div>

  <div class="pj-password-form__field" data-pj-password-field="confirmPassword">
    <aprova-input
      _id="pj-confirm-password"
      [inputType]="!showConfirmPassword() ? 'password' : 'text'"
      [control]="form.controls.confirmPassword"
      label="Confirmar senha"
      (onInput)="validateConfirmPasswordRules()"
      (onFocus)="showPasswordRulesTooltip('confirmPassword', $event)"
      (onBlur)="clearFocusedField()"
    >
      <ng-container append>
        <aprova-icon
          [name]="!showConfirmPassword() ? 'eye-off-outline' : 'eye-outline'"
          size="20px"
          color="#9ca3af"
          class="cursor-pointer"
          (click)="togglePassword(true)"
        />
      </ng-container>
    </aprova-input>
  </div>
  </div>

  @if (focusedField()) {
    <div class="pj-password-form__rules-box">
      <app-form-rules-box
        [title]="'Para sua segurança, crie uma senha forte seguindo esses requisitos'"
        [rules]="focusedField() === 'confirmPassword' ? confirmPasswordRules : passwordRules"
      />
    </div>
  }

  <div class="pj-password-form__terms">
    <aprova-checkbox
      [control]="form.controls.termos"
      color="#06929F"
    >
      Li e aceito os
      <a
        href="https://assets-publicos.s3.amazonaws.com/Termos+de+Uso.pdf"
        target="_blank"
        class="pj-password-form__terms-link"
      >
        termos de uso
      </a>
    </aprova-checkbox>

    @if (form.controls.termos.errors && !form.controls.termos.pristine) {
      <p class="pj-password-form__terms-error">
        É necessário concordar com os termos de uso para prosseguir.
      </p>
    }
  </div>

  @if (!hideRecaptcha) {
    <aprova-recaptcha [recaptchaFormControl]="form.controls.recaptchaReactive" />
  }
</div>
